import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var EmptySavedSearch = function EmptySavedSearch() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "min-h-[calc(100vh-61px)] bg-white-ghost flex  flex-col items-center lg:min-h-[calc(100vh-70px)] justify-start pt-32 lg:pt-20 lg:gap-[72px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block lg:text-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary font-bold text-2xl text-center"
  }, t("saved_searches_2", {
    ns: "saved_search"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-4 lg:p-10 lg:bg-white lg:min-w-[440px] lg:rounded-3xl lg:gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-[156px] h-[156px]",
    src: CDN_LINK + "/assets/images/bookmark.png",
    alt: "bookmark"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-xl font-bold text-center"
  }, t("don_t_saved_searches", {
    ns: "saved_search"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-primary text-center text-base font-semibold"
  }, t("save_searches_search_page", {
    ns: "saved_search"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/filters"),
    className: "bg-primary text-white text-base font-semibold p-3 rounded mt-8 hover:text-white border-0 outline-none w-[250px] text-center lg:mt-6",
    role: "button"
  }, t("go_search_page", {
    ns: "saved_search"
  })))));
};
export default EmptySavedSearch;